
export default{
    async getQaIndex({}, recommented_count){
        return await this.$axios.$post(
            this.$api.user.qanda.getIndex,
            {recommented_count: recommented_count}
        )
    },
    async getQaDetail({}, category_id){
        return await this.$axios.$post(
            this.$api.user.qanda.getDetail,
            {category_id: category_id}
        )
    },
}